var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_3347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_3347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 8.5,
    rx: 26,
    ry: 22.5,
    fill: "#58B310"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_254_3347",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_254_3347",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.4f688234d2ffc56ddfdd7c3c439b5577.svg";
export { ForwardRef as ReactComponent };